'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _displayTools = require('../../utils/display-tools');

var defaults = {
	/*
 Line Chart
  */
	line: {
		animation: {
			duration: 0
		},
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true,
					callback: function callback(value, index, values) {
						return new Intl.NumberFormat('en-GB', {
							style: 'currency',
							currency: 'GBP',
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
							currencyDisplay: 'symbol'
						}).format(value);
					}
				}
			}]
		},
		tooltips: {
			callbacks: {
				title: function title(items, data) {
					return (0, _displayTools.formatTitle)(data.labels[items[0].index]);
				},
				beforeLabel: function beforeLabel(item, data) {
					return null;
				},
				label: function label(item, data) {

					var value = data.datasets[item.datasetIndex].data[item.index];
					var key = data.datasets[item.datasetIndex].label;

					return (0, _displayTools.formatTitle)(key) + ': ' + (0, _displayTools.formatValue)(value, key);
				}
			}
		}
	},

	/*
 Pie Chart
  */
	pie: {
		// maintainAspectRatio: false,
		animation: {
			duration: 0
		},
		scales: {},
		legend: {
			display: false
		},
		tooltips: {
			callbacks: {
				title: function title(items, data) {
					return data.labels[items[0].index];
				},
				beforeLabel: function beforeLabel(item, data) {
					return null;
				},
				label: function label(item, data) {

					var value = data.datasets[item.datasetIndex].data[item.index];
					var key = data.datasets[item.datasetIndex].label;

					return (0, _displayTools.formatTitle)(key) + ': ' + (0, _displayTools.formatValue)(value, key);
				}
			}
		}
	},

	/*
 Pie Chart
  */
	radar: {
		scale: {
			ticks: {
				beginAtZero: true,
				callback: function callback(value, index, values) {
					return new Intl.NumberFormat('en-GB', {
						style: 'currency',
						currency: 'GBP',
						minimumFractionDigits: 0,
						maximumFractionDigits: 0,
						currencyDisplay: 'symbol'
					}).format(value);
				}
			}
		},
		animation: {
			duration: 0
		},
		tooltips: {
			callbacks: {
				title: function title(items, data) {
					return data.labels[items[0].index];
				},
				beforeLabel: function beforeLabel(item, data) {
					return null;
				},
				label: function label(item, data) {

					var value = data.datasets[item.datasetIndex].data[item.index];
					var key = data.datasets[item.datasetIndex].label;

					return (0, _displayTools.formatTitle)(key) + ': ' + (0, _displayTools.formatValue)(value, key);
				}
			}
		}
	},

	/*
 Bar Chart
 */
	bar: {
		animation: {
			duration: 0
		},
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true,
					callback: function callback(val) {
						return new Intl.NumberFormat('en-GB', {
							style: 'currency',
							currency: 'GBP',
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
							currencyDisplay: 'symbol'
						}).format(val);
					}
				}
			}],
			xAxes: [{
				ticks: {
					display: true
				},
				gridLines: {
					display: false
				}
			}]
		},
		tooltips: {
			callbacks: {
				title: function title(items, data) {
					return data.labels[items[0].index];
				},
				beforeLabel: function beforeLabel(item, data) {},
				label: function label(item, data) {
					return new Intl.NumberFormat('en-GB', {
						style: 'currency',
						currency: 'GBP',
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
						currencyDisplay: 'symbol'
					}).format(item.yLabel);
				}
			}
		}
	}
};

exports.default = defaults;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/charts/defaultOptions.js
// module id = 561
// module chunks = 0